
import { designMode } from '@/env';
import { Component, Vue } from 'vue-property-decorator';
import { store } from '@/store';
import { dispatchCheckLoggedIn, dispatchCheckSetupCompleted } from '@/store/main/actions';
import { readHasAdminAccess, readIsLoggedIn, readIsSetupCompleted } from '@/store/main/getters';
import { getState, removeState, toBoolean } from '@/utils';
import { readReportId } from '@/store/report/getters';
import { readCompanyId } from '@/store/admin/getters';

const startRouteGuard = async (to, from, next) => {
  await dispatchCheckLoggedIn(store);
  if (readIsLoggedIn(store)) {
    await dispatchCheckSetupCompleted(store);
    if (readHasAdminAccess(store)) {
      if (readReportId(store) || readCompanyId(store)) {
        next();
      } else {
        if ((to.path as string).startsWith('/main/admin')) {
          next();
        } else {
          next('/main/admin');
        }
      }
    } else if (readIsSetupCompleted(store)) {
      next();
    } else {
      next('/setup/basic');
    }
  } else if (readIsLoggedIn(store) === false) {
    if ((to.path as string).startsWith('/main')) {
      next('/login');
    } else {
      next();
    }
  }
};

@Component
export default class Start extends Vue {
  public beforeRouteEnter(to, from, next) {
    const state = getState();
    if ((state && state == 'google-auth') || toBoolean(designMode)) {
      next();
      removeState();
    } else {
      startRouteGuard(to, from, next);
    }
  }

  public beforeRouteUpdate(to, from, next) {
    if ((from.path as string).endsWith('callback') || toBoolean(designMode)) {
      next();
    } else {
      startRouteGuard(to, from, next);
    }
  }
}
